export const k8sBasePath = `${window.SERVER_FLAGS.basePath}api/kubernetes`;
